<template>

    <div class="card shadow" :class="type === 'dark' ? 'bg-default' : ''">
        <div class="card-header border-0" :class="type === 'dark' ? 'bg-transparent' : ''">
            <div class="row align-items-center">
                <div id="errorNotification" class="col-md-12">
                    <base-alert v-if="errorMessage != null" type="danger">
                        <span class="alert-inner--text"> {{ errorMessage }}</span>
                        <button type="button" class="close" aria-label="Close" @click="removeMessage('error')">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </base-alert>
                    <base-alert v-if="successMessage != null" type="success">
                        <span class="alert-inner--text"> {{ successMessage }}</span>
                        <button type="button" class="close" aria-label="Close" @click="removeMessage('success')">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </base-alert>
                </div>
                <div class="col-md-3">
                    <h3 class="mb-0" :class="type === 'dark' ? 'text-white' : ''">
                        {{ _.startCase(currentProfile) }}
                    </h3>
                </div>
                <div class="col-md-9 text-right">
                    <div v-if="(filterText.site_id > 0 || terminal_id > 0) && checkedItems.length == 0">
                        <base-button class="float-right ml-1" type="primary" size="sm"
                            @click.prevent="resendTransactions(filterText)">Resend All Transactions for
                            this {{ filterText.terminal_id > 0 ? 'Terminal' : 'Site' }}</base-button>
                        <div class="ml-1"></div>
                    </div>
                    <div v-else-if="checkedItems.length > 0">
                        <base-button class="float-right ml-1" type="primary" size="sm"
                            @click.prevent="massupdate('integration_export_flag', false)">Resend Selected
                            Transactions</base-button>
                        <div class="ml-1"></div>
                    </div>
                </div>
            </div>
        </div>

        <div class="table-responsive">
            <vuetable ref="vuetable" :api-url="apiURL" :http-options="httpOptions" :fields="fields"
                :sort-order="sortOrder" :show-sort-icons="true" :per-page="10" :css="css.table" pagination-path=""
                data-path="data" no-data-template="Empty" @vuetable:checkbox-toggled-all="log"
                @vuetable:checkbox-toggled="log" @vuetable:load-error="onLoadError"
                @vuetable:pagination-data="onPaginationData">

                <template slot="actions" slot-scope="props">
                    <center>
                        <button :disabled="!props.rowData.integration_export_flag" class="btn btn-primary btn-sm"
                            @click.prevent="resendTransaction(props.rowData.id)">Resend</button>
                    </center>
                </template>

            </vuetable>
        </div>

        <div class="card-footer d-flex justify-content-end" :class="type === 'dark' ? 'bg-transparent' : ''">
            <div class="pagination ui basic segment grid">
                <vuetable-pagination ref="pagination" @vuetable-pagination:change-page="onChangePage"
                    :css="css.pagination">
                </vuetable-pagination>
            </div>
        </div>

    </div>
</template>

<script>
import {
    mapState
} from 'vuex'

import Vuetable from "vuetable-2/src/components/Vuetable";
import VuetablePagination from "vuetable-2/src/components/VuetablePagination";
import secureStorage from '../../controllers/secureStorage';
import HTTPRequest from '../../controllers/httpRequest.js';
import moment from 'moment';

var component_x;

export default {
    name: 'profiles-table',
    props: {
        type: {
            type: String
        },
        title: String,
        filterText: Object
    },
    components: {
        Vuetable,
        VuetablePagination
    },
    computed: {
        ...mapState(['currentProfile', 'currentApiURL', 'endPoint', 'parameters', 'serverType'])
    },
    data() {
        return {
            filterStatus: "",
            profileAction: "",
            errorMessage: null,
            successMessage: null,
            componentKey: 0,
            visible: false,
            availableFields: [],
            apiURL: "",
            fields: ["__checkbox",
                { name: "terminal_name", title: "Terminal" },
                { name: "site_name", title: "Site" },
                { name: "trans_id", title: "Trans ID" },
                { name: "business_date_formatted", title: "Business Date" },
                {
                    name: "processed_status",
                    title: "Status",
                    callback: (value) => {
                        const statusMap = {
                            'P': "Posted",
                            'R': "Returned",
                            'V': "Voided",
                            'S': "Suspended",
                            'A': "Aborted"
                        };
                        return statusMap[value] || value;
                    }
                },
                {
                    name: "integration_export_flag",
                    title: "Sent to PDE",
                    callback: (value) => {
                        return value ? "Yes" : "No"
                    }
                },
                '__slot:actions'
            ],
            sortOrder: [{
                field: "business_date",
                direction: "asc"
            }],
            httpOptions: {
                headers: {
                    Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), 'Request-Source': "BXI-Web"
                }
            },
            css: {
                table: {
                    tableClass: 'table table-sm table-striped table-bordered table-hovered',
                    loadingClass: 'loading'
                },
                pagination: {
                    infoClass: 'pull-right',
                    wrapperClass: 'vuetable-pagination pull-right',
                    activeClass: 'btn-primary btn-sm',
                    disabledClass: 'disabled',
                    pageClass: 'btn btn-border',
                    linkClass: 'btn btn-border',
                    icons: {
                        first: '',
                        prev: '',
                        next: '',
                        last: '',
                    },
                }
            },
            checkedItems: []
        }
    },
    watch: {
        currentApiURL: function () {
            this.$refs.vuetable.resetData()
            // this.apiURL = this.currentApiURL
            this.apiURL = this.endPoint + 'pos_documents'
        },
        parameters: function () {
            // this.apiURL = this.currentApiURL
            // this.apiURL = this.apiURL + this.parameters
            this.apiURL = this.endPoint + 'pos_documents' + this.parameters
            this.$refs.vuetable.selectedTo = []
            this.checkedItems = []
            console.log(this.filterText)
        }
    },
    methods: {
        moment,
        refreshPage() {
            this.onClose()
            this.$refs.vuetable.refresh()
            this.successMessage = "Successful Operation"
            this.errorMessage = null
        },
        removeMessage(type) {
            if (type == 'error')
                this.errorMessage = null
            else
                this.successMessage = null
        },
        async onPaginationData(paginationData) {
            this.$refs.pagination.setPaginationData(paginationData);
        },
        async onLoadError(error) {
            if (error.response.status == 401) {
                var auth_response = await HTTPRequest.authenticate(component_x.endPoint)
                if (auth_response["status"] == "Ok") {
                    this.$router.go();
                } else {
                    alert("Cannot get access token. Please login again.")
                    this.$router.push("/")
                }
            } else {
                if (error.response.data.error == "Session expired") {
                    alert("Session is already expired. Please login again.")
                    document.getElementById("logoutButton").click()
                }
            }
        },
        onChangePage(page) {
            this.$refs.vuetable.changePage(page);
        },
        resendTransaction(id) {
            let payload = {
                "integration_export_flag": false
            }
            HTTPRequest.putRequest(component_x.endPoint + 'pos_documents/' + id, null, payload)
                .then(response => {
                    this.$notification['success']({
                        message: 'Successfully Flagged Transaction for Lynexus Resending',
                        description: "Terminal ID: " + response.terminal_id + "\nTrans ID: " + response.trans_id
                    })
                    this.$refs.vuetable.refresh()
                })
                .catch(error => {
                    this.$notification['error']({
                        message: 'Failed to Flag Transaction for Lynexus Resending',
                        description: "Terminal ID: " + error.response.data.terminal_id + "\nTrans ID: " + error.response.data.trans_id
                    })
                })
        },
        log() {
            this.checkedItems = this.$refs.vuetable.selectedTo
        },
        async massupdate(field_name, value) {
            var field_update = {}
            field_update[field_name] = value
            var payload = {
                ids: this.checkedItems,
                field_update: field_update
            }
            var response = await HTTPRequest.postRequest(this.endPoint + "pos_documents/mass_update", null,
                payload)
            if (response["message"] == "Success") {
                this.$notification['success']({
                    message: 'Successfully Flagged' + this.checkedItems.length + ' Transaction' + (this.checkedItems.length > 1 ? 's' : '') + ' for Lynexus Resending'
                })
                this.$refs.vuetable.refresh()
                this.checkedItems = []
                this.$refs.vuetable.selectedTo = []
            } else {
                this.errorMessage = response["error"]
            }
        },
        async resendTransactions(params) {
            var payload = {
                terminal_id: params.terminal_id,
                site_id: params.site_id,
                from_date: this.moment(params.business_date[1]).format('YYYY-MM-DD'),
                to_date: this.moment(params.business_date[1]).format('YYYY-MM-DD')
            }
            await HTTPRequest.postRequest(this.endPoint + "pos_documents/reset_integration_export_flag", null, payload)
                .then(response => {
                    console.log(response)
                    this.$notification['success']({
                        message: 'Successfully Flagged Transactions for Lynexus Resending'
                    })
                    this.$refs.vuetable.refresh()
                })
                .catch(error => {
                    console.log(error)
                    this.$notification['error']({
                        message: 'Failed to Flag Transaction for Lynexus Resending'
                    })
                })
        }
    },
    mounted: function () {
        component_x = this;
        this.apiURL = this.endPoint + 'pos_documents' + this.parameters
    }
}
</script>

<style></style>